// @flow
import { DEFAULT_BROWSER_FONT } from './config'; // em units are consistent accross browsers
// read more: https://zellwk.com/blog/media-query-units/

var customMediaQuery = function customMediaQuery(maxWidthPx
/*: number */
) {
  return (
    /*: string */
    "@media (max-width: " + maxWidthPx / DEFAULT_BROWSER_FONT + "em)"
  );
};

var customMediaQueryMinWidth = function customMediaQueryMinWidth(minWidthPx
/*: number */
) {
  return (
    /*: string */
    "@media (min-width: " + minWidthPx / DEFAULT_BROWSER_FONT + "em)"
  );
};

var xs = 320;
var sm = 600;
var md = 990;
var lg = 1800;

var createMedia = function createMedia() {
  return {
    max: function max(maxWidthPx
    /*: number */
    ) {
      return customMediaQuery(maxWidthPx);
    },
    min: function min(minWidthPx
    /*: number */
    ) {
      return customMediaQueryMinWidth(minWidthPx);
    },
    xs: customMediaQuery(xs),
    sm: customMediaQuery(sm),
    md: customMediaQuery(md),
    lg: customMediaQuery(lg),
    xl: customMediaQueryMinWidth(lg + 1),
    // use UNSAFE_break in browsers only when you can't use media directly
    UNSAFE_break: {
      xs: xs,
      sm: sm,
      md: md,
      lg: lg
    }
  };
};

export default createMedia;